import React, { useState, useEffect } from 'react';
import ProgressionButtons from '../components/ProgressionButtons';

const QuestionComponent = ({
	questionText,
	imageSrc,
	altText,
	formData,
	onBack,
	onUpdate,
	onNext,
	activityIndex, // Pass this as a prop to identify the activity
}) => {
	// State to manage the user's answer
	const [answers, setAnswers] = useState('');
	const [errorMessage, setErrorMessage] = useState('');

	useEffect(() => {
		// Find the data for the current activity
		const currentActivityData = formData?.activities?.find(
			(item) => item?.activity === activityIndex
		);
		console.log(formData);

		if (currentActivityData && currentActivityData?.answers) {
			// Set the answer from formData if it exists
			setAnswers(currentActivityData.answers[0] || '');
		} else {
			// Set to empty if no answer is found
			setAnswers('');
		}
	}, [activityIndex, formData]);

	// Function to handle input change
	const handleInputChange = (event) => {
		const nextAnswer = event.target.value;
		setAnswers(nextAnswer);
		setErrorMessage('');
		onUpdate?.({ answers: [nextAnswer] });
	};

	// Function to handle Next button click
	const handleNextClick = () => {
		if (!answers.trim()) {
			setErrorMessage('Please provide an answer before continuing.');
			return false;
		}
		// Pass the answer data back to the parent component
		return onNext([answers]);
	};

	return (
		<>
			<div className="question-box py-3">
				<div className="question-box-header m-auto">
					<h1 className="mb-0">Question:</h1>
					<h2 style={{ color: '#5B616A' }} className="mb-0 d-flex ms-1">
						{questionText}
					</h2>
					{imageSrc && <img src={imageSrc} alt={altText} className="mx-1 fiveImg " />}
					<h2 className="" style={{ color: '#5B616A' }}>
						{altText}
					</h2>
				</div>
				<div className="text-area-box px-4 mt-4">
					<textarea
						rows="6"
						placeholder="Type your answer here..."
						value={answers} // Bind the textarea value to state
						onChange={handleInputChange} // Update state on input change
					/>
				</div>
			</div>
			{errorMessage && <div className="text-danger">{errorMessage}</div>}
			<div className="mt-3">
				<ProgressionButtons
					variant={onBack ? 'both' : 'next'}
					onClickPrev={onBack}
					onClickNext={handleNextClick}
				/>
			</div>
		</>
	);
};

export default QuestionComponent;
